// VENDOR IMPORTS
import Vendor_login from "./components/Vendor_login";
import Vendor_details from "./components/vendor_details";
import vendor_gst_delivery_details from "./components/vendor_gst_delivery_details";
import Vendor_category_speciality_details_page from "./components/vendor_category_speciality_details";
import Vendor_product_service_listing from "./components/vendor_product_service_listing";
import Vendor_upload_documents from "./components/vendor_upload_documents";
import vendor_image_cropperjs from "./components/vendor_image_cropperjs";
import vendor_summary from "./components/vendor_summary";
import vendorServicing_dashboard from "./components/vendorServicing_dashboard";
import vendorServicing_orders from "./components/vendorServicing_orders";
import Vendor_security from "./components/Vendor_security";
import vendorServicing_profile from "./components/vendorServicing_profile";
import vendor_manage_address from "./components/vendor_manage_address";
import vendorServicing_order_details from "./components/vendorServicing_order_details";
import vendorServicing_order_details_email from "./components/vendorServicing_order_details_email";
import vendor_servicing_docs from "./components/vendor_servicing_docs";
import vendor_email_report from "./components/vendor_email_report";
import vendorServicing_billing from "./components/vendorServicing_billing";
import vendorServicing_help from "./components/vendorServicing_help";
import vendor_calender from "./components/vendor_calender";
import vendor_delivery from "./components/vendor_delivery";
import vendor_servicing_product_listing from "./components/vendor_servicing_product_listing";
import vendor_servicing_product_details from "./components/vendor_servicing_product_details";
import vendorServicing_navbar from "./components/vendorServicing_navbar";
import vendorServicing_points from "./components/vendorServicing_points";
import vendorServicing_paymentStatus from "./components/vendorServicing_paymentStatus";
import vendor_servicing_pricing from "./components/vendor_servicing_pricing";
import vendor_gst from "./components/vendor_gst";
import vendor_servicing_payment from "./components/vendor_servicing_payment";
import vendorPaymentsInstamojo from "./components/vendorPaymentsInstamojo";
import vendorPaymentsPage from "./components/vendorPaymentsPage";
import vendorQuoteRequests from "./components/vendorQuoteRequests";
import vendor_website_templates from "./components/vendor_website_templates";
import admin_control from "./components/admin_control";
import Util from "./helpers/util";
import trixUtil from "./helpers/trixUtil";

const trixObject = new trixUtil();
trixObject.trixCustomToolBar();

const UtilObject = new Util();

class VendorApp {
  constructor() {
    this.init();
  }

  async init() {
    this._setGlobals();
    await UtilObject.preloadCookies();
    this._initVendorComponents();
    this.visitorCount();
    console.log("Locaso: VendorApp initialized");
  }

  _setGlobals() {
    globalThis.X_API_KEY = window.CONFIG?.X_API_KEY || "KFvDq77oq74WjKXKon4AIzaSyBzKejuO2tJjzKJ";
    const rawBaseURL = document.getElementsByClassName("baseURL")[0]?.value || window.location.origin + "/";
    globalThis.baseURL = rawBaseURL.endsWith("/") ? rawBaseURL : rawBaseURL + "/";
    globalThis.S3BaseURL = "https://locaso-data-pro.s3.ap-south-1.amazonaws.com/Vendor/";
    
    // Restore all legacy globals from app.js
    globalThis.LAT = null;
    globalThis.LNG = null;
    globalThis.BUFFER = 100;
    globalThis.addressDetails = {};
    globalThis.customerID = null;
    globalThis.orderID = null;
    globalThis.cropperMain = null;
    globalThis.orderDetalisMain = false;
    globalThis.cropperC = "";
  }

  _initVendorComponents() {
    const has = (selector) => $(selector).length > 0;
    const isVisible = (selector) => $(selector).length > 0 && !$(selector).hasClass("d-none");

    // 1. Initialize Essential/Global Components immediately
    if (has(".adminControl"))                            new admin_control();
    if (has(".vendor-login"))                            new Vendor_login();
    if (has(".vendorServicingNav"))                      new vendorServicing_navbar();
    if (has(".VendorSummaryPage"))                       new vendor_summary();

    // 2. Map of secondary components
    const dashboardComponents = [
      { sel: ".VendorDashboardPage", cls: vendorServicing_dashboard },
      { sel: ".vendororders", cls: vendorServicing_orders },
      { sel: ".vendor_name_edit_page", cls: vendorServicing_profile },
      { sel: ".vendorServicingDocuments", cls: vendor_servicing_docs },
      { sel: ".VendorAccountSecurity", cls: Vendor_security },
      { sel: "#VendorAddressDiv", cls: vendor_manage_address },
      { sel: ".vendor_email_report", cls: vendor_email_report },
      { sel: ".vendorbilling", cls: vendorServicing_billing },
      { sel: ".vendorConfirmationHelpPageDesktop", cls: vendorServicing_help },
      { sel: ".vendorCalenderPage", cls: vendor_calender },
      { sel: ".deliveryDetailsPage", cls: vendor_delivery },
      { sel: ".vendor_servicing_product_listing", cls: vendor_servicing_product_listing },
      { sel: ".vendorPoints", cls: vendorServicing_points },
      { sel: ".vendor_servicing_pricing", cls: vendor_servicing_pricing },
      { sel: ".vendorHasGSTdiv", cls: vendor_gst },
      { sel: ".vendor_servicing_payment", cls: vendor_servicing_payment },
      { sel: ".paymentStatusPage", cls: vendorServicing_paymentStatus },
      { sel: ".vendor_servicing_payment_Instamojo", cls: vendorPaymentsInstamojo },
      { sel: ".vendorPaymentsPage", cls: vendorPaymentsPage },
      { sel: ".vendorQuoteRequestsPage", cls: vendorQuoteRequests },
      { sel: ".vendorWebsiteTemplatesPage", cls: vendor_website_templates },
      { sel: ".vendorPage", cls: vendor_image_cropperjs },
      { sel: ".basicDetails-page", cls: Vendor_details },
      { sel: ".Vendor_category_speciality_details_page", cls: Vendor_category_speciality_details_page },
      { sel: ".product-services-listing-page", cls: Vendor_product_service_listing },
      { sel: ".vendorServicingDocuments", cls: Vendor_upload_documents }
    ];

    // 3. Stagger initialization: Visible ones first, others delayed
    let delayCounter = 1;
    dashboardComponents.forEach((comp) => {
      if (has(comp.sel)) {
        try {
          if (isVisible(comp.sel)) {
            // console.log(`Initializing visible component: ${comp.sel}`);
            new comp.cls();
          } else {
            // Stagger hidden components to prevent overwhelming the server with simultaneous AJAX calls
            setTimeout(() => {
              try {
                // console.log(`Lazy-initializing background component: ${comp.sel}`);
                new comp.cls();
              } catch (e) {
                console.error(`Lazy-initialization failed for ${comp.sel}:`, e);
              }
            }, 400 * delayCounter++);
          }
        } catch (e) {
          console.error(`Initialization failed for ${comp.sel}:`, e);
        }
      }
    });
  }

  visitorCount() {
    const throttleKey = "locaso:visitor:vendor:lastHitAt";
    const throttleMs = 30000;
    const lastHitAt = Number.parseInt(sessionStorage.getItem(throttleKey) || "0", 10);
    if (Date.now() - lastHitAt < throttleMs) {
      return;
    }
    sessionStorage.setItem(throttleKey, String(Date.now()));

    $.ajax({
      type: "POST",
      url: globalThis.baseURL + "api/visitor/updateVisitorCount",
      data: { type: "visit", section: "VENDOR" },
      headers: { Authorization: globalThis.X_API_KEY }
    });
  }
}

$(document).ready(() => { new VendorApp(); });
